import { getOsLanguagesFilter } from "@/helpers/filters.helper"
import { OSLanguages } from "@/icons"
import { RadioFilter } from "../RadioFilter"

import type { TFunction } from "@/hooks/useTranslation"

export interface OSLanguagesFilterProps {
  isLoading?: boolean
  options: any
  placement: string
  t: TFunction
}

export const OSLanguagesFilter = (props: OSLanguagesFilterProps) => {
  const { isLoading, options, placement, t } = props
  const filter = getOsLanguagesFilter(t)
  const { options: defaultOptions, ...osLanguagesFilter } = filter

  const title = osLanguagesFilter.displayLabel || ""

  const items = [
    {
      title,
      options: options || defaultOptions,
      Icon: OSLanguages,
      key: osLanguagesFilter.key,
      order: 1
    }
  ]

  return (
    <RadioFilter
      title={title}
      items={items}
      isLoading={isLoading}
      placement={placement}
      name={osLanguagesFilter.key}
    />
  )
}
